import axios from 'axios'
import store from '../store'
import { hex_md5 } from './md4.js'

const ANONYMOUS_ID_KEY = 'mw_anonymous_id'
const SESSION_ID_KEY = 'mw_session_id'
const WALLET_OPEN_KEY = 'mw_wallet_open_reported'
const WALLET_OPEN_TS_KEY = 'mw_wallet_open_ts'
const WITHDRAW_FLOW_TS_KEY = 'mw_withdraw_flow_ts'
const WITHDRAW_PAGE_TS_KEY = 'mw_withdraw_page_ts'

function createId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function getAnonymousId() {
  try {
    let id = localStorage.getItem(ANONYMOUS_ID_KEY)
    if (!id) {
      id = createId()
      localStorage.setItem(ANONYMOUS_ID_KEY, id)
    }
    return id
  } catch (_err) {
    return 'unknown'
  }
}

export function getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_ID_KEY)
    if (!id) {
      id = createId()
      sessionStorage.setItem(SESSION_ID_KEY, id)
    }
    return id
  } catch (_err) {
    return 'unknown'
  }
}

function getSessionNumber(key) {
  try {
    const raw = sessionStorage.getItem(key)
    const value = Number(raw)
    return raw && !Number.isNaN(value) && value > 0 ? value : 0
  } catch (_err) {
    return 0
  }
}

function setSessionValue(key, value) {
  try {
    sessionStorage.setItem(key, String(value))
  } catch (_err) {
    // ignore quota / private mode
  }
}

export function markWalletOpenTs() {
  if (!getSessionNumber(WALLET_OPEN_TS_KEY)) {
    setSessionValue(WALLET_OPEN_TS_KEY, Date.now())
  }
}

export function markWithdrawFlowStart() {
  if (!getSessionNumber(WITHDRAW_FLOW_TS_KEY)) {
    setSessionValue(WITHDRAW_FLOW_TS_KEY, Date.now())
  }
}

export function markWithdrawPageStart() {
  setSessionValue(WITHDRAW_PAGE_TS_KEY, Date.now())
}

export function getWithdrawDurationExtra() {
  const now = Date.now()
  const openTs = getSessionNumber(WALLET_OPEN_TS_KEY)
  const flowTs = getSessionNumber(WITHDRAW_FLOW_TS_KEY)
  const pageTs = getSessionNumber(WITHDRAW_PAGE_TS_KEY)
  const startTs = flowTs || pageTs || openTs
  const extra = {}
  if (startTs) {
    extra.start_ts = startTs
    extra.duration_ms = Math.max(0, now - startTs)
  }
  if (pageTs) {
    extra.page_start_ts = pageTs
    extra.page_duration_ms = Math.max(0, now - pageTs)
  }
  if (openTs) {
    extra.open_start_ts = openTs
    extra.open_duration_ms = Math.max(0, now - openTs)
  }
  return extra
}

function normalizeExtra(extra) {
  const merged = {
    session_id: getSessionId(),
    anonymous_id: getAnonymousId(),
    ...(extra || {})
  }
  const out = {}
  Object.keys(merged).forEach((key) => {
    if (merged[key] === undefined || merged[key] === null) return
    out[key] = String(merged[key])
  })
  return out
}

// postReportLog({
//   log_id: '440', // 埋点id必填
//   extra, // 拓展字段（json格式）必填
// })
export function postReportLog(data) {
  const env = process.env.NODE_ENV === 'production' ? 'prod' : 'test'
  if (env === 'test') {
    // console.log('[埋点]', data.log_id, data.extra)
    return
  }
  // 获取东八区时间
  const date = new Date()
  const chinaTimeStr = date.toLocaleString('zh-CN', {
    timeZone: 'Asia/Shanghai',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    fractionalSecondDigits: 3
  })
  const extra = normalizeExtra(data.extra)
  const logData = {
    userid: (store.state.userInfo && store.state.userInfo.userId) || '1', // 用户id必填
    ts: chinaTimeStr.replace(/\//g, '-'), // 业务发生时间必填
    app_type: 'Metwallet', // 应用类型必填
    app_version: '20260722', // 应用版本必填
    is_server_log: '1',
    ...data,
    extra: JSON.stringify(extra)
  }
  const sign = getDataSign(logData)
  logData.sign = sign
  axios.post('https://logapi.ichamet.com/report/log', logData)
}

export function reportWalletOpenOnce(extra) {
  try {
    if (sessionStorage.getItem(WALLET_OPEN_KEY)) return
    sessionStorage.setItem(WALLET_OPEN_KEY, '1')
    markWalletOpenTs()
  } catch (_err) {
    return
  }
  postReportLog({
    log_id: '440',
    extra: {
      page: 'wallet_open',
      apptype: (typeof localStorage !== 'undefined' && localStorage.getItem('apptype')) || '',
      ...extra
    }
  })
}

// 获取大数据请求的 sign
export function getDataSign(params, randomStr = '123') {
  const map = new Map(Object.entries(params).sort())
  const mapKeys = Array.from(map.keys())
  let sign = ''
  mapKeys.forEach((key) => {
    if (key !== 'sign' && key !== 'extra') {
      sign += `${key}=${params[key].toString()}&`
    } else if (key === 'extra') {
      const extraMap = new Map(Object.entries(JSON.parse(params[key])).sort())
      sign += `${key}=${convertMapToString(extraMap)}&`
    }
  })
  sign = sign.slice(0, sign.length - 1)
  sign += randomStr
  return hex_md5(sign).toLowerCase()
}

export function convertMapToString(map) {
  let str = '{'
  map.forEach((value, key) => {
    str += `${key}=${value}, `
  })
  str = str.slice(0, -2) + '}'
  return str
}



// WEBPACK FOOTER //
// ./src/utils/log.js